// The password is only required in create mode.
import {TFunction} from "i18next";
import * as yup from "yup";
import {PermissionLevel} from "../../app/api/model/user";

export const getUserValidationSchema = (t: TFunction, isCreateUser = false) =>
    yup.object({
        email: yup.string().email(t("validation_invalidEmail")).required(t("validation_inputRequired")),
        firstName: yup.string().required(t("validation_inputRequired")),
        lastName: yup.string().required(t("validation_inputRequired")),
        status: yup.string().oneOf(["ACTIVE", "INACTIVE"]).required(t("validation_inputRequired")),
        permissionLevel: yup
            .number()
            .oneOf([PermissionLevel.VIEW_ONLY, PermissionLevel.SUPPORT, PermissionLevel.MANAGER, PermissionLevel.ADMIN])
            .required(t("validation_inputRequired")),
        ...(isCreateUser && {
            password: yup.string().required(t("validation_inputRequired")),
            passwordConfirmation: yup
                .string()
                .test("passwords-match", t("validation_passwordMustMatch"), function (value) {
                    return this.parent.password === value;
                }),
        }),
        ...(!isCreateUser && {
            password: yup.string(),
            passwordConfirmation: yup
                .string()
                .test("passwords-match", t("validation_passwordMustMatch"), function (value) {
                    return this.parent.password === value;
                }),
        }),
    });
